import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import VideoCard from 'components/Motion_Detection/Videos/video-instar-cloud-administration';
import NavButtons from 'components/Motion_Detection/INSTAR_Cloud/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "INSTAR Cloud - Administration",
  "path": "/Bewegungserkennung/INSTAR_Cloud/Video/Administration/",
  "dateChanged": "2017-11-27",
  "author": "Mike Polinowski",
  "excerpt": "Wenn Ihnen kein FTP Server zur Verfügung steht, können Sie Ihre Alarmaufnahmen auch in der INSTAR Cloud speichern und verwalten.",
  "image": "MD_SearchThumb_Cloud_Administration.png",
  "social": "/images/Search/MD_SearchThumb_Cloud_Administration.webp",
  "toc": "/images/Search/TOC_Icons/TOC_Icons_WebUI_Cloud.webp",
  "chapter": "Motion Detection"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <SEOHelmet title='INSTAR Cloud - Administration' dateChanged='2017-11-27' author='Mike Polinowski' tag='INSTAR IP Camera' description='INSTAR Cloud ist eine Aufnahmeplattform die rein auf deutschen Servern entsprechend der DSVGO läuft. Hier zeigen wir ihre Vorteile sowie Funktionalitäten einschließlich KI-Funktionen.' image='/images/Search/MD_SearchThumb_Cloud_Administration.png' twitter='/images/Search/MD_SearchThumb_Cloud_Administration.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Motion_Detection/INSTAR_Cloud/Administration/' locationFR='/fr/Motion_Detection/INSTAR_Cloud/Administration/' crumbLabel="Admin" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h2 {...{
      "id": "instar-cloud",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#instar-cloud",
        "aria-label": "instar cloud permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`INSTAR Cloud`}</h2>
    <h3 {...{
      "id": "administration",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#administration",
        "aria-label": "administration permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Administration`}</h3>
    <p>{`INSTAR Cloud ist eine Aufnahmeplattform die rein auf deutschen Servern entsprechend der DSVGO läuft. Hier zeigen wir ihre Vorteile sowie Funktionalitäten einschließlich KI-Funktionen.`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <VideoCard mdxType="VideoCard" />
    <EuiSpacer mdxType="EuiSpacer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      